/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Authentication methods */
export enum AuthenticationMethod {
  Password,
  DigitalSignature,
  Biometric,
  Token,
  Certificate,
  Sms,
  Email,
  App,
  Hardware,
}

export type AuthenticationMethodArgs = AuthenticationMethod;

export function getAuthenticationMethodEncoder(): FixedSizeEncoder<AuthenticationMethodArgs> {
  return getEnumEncoder(AuthenticationMethod);
}

export function getAuthenticationMethodDecoder(): FixedSizeDecoder<AuthenticationMethod> {
  return getEnumDecoder(AuthenticationMethod);
}

export function getAuthenticationMethodCodec(): FixedSizeCodec<
  AuthenticationMethodArgs,
  AuthenticationMethod
> {
  return combineCodec(
    getAuthenticationMethodEncoder(),
    getAuthenticationMethodDecoder(),
  );
}
